import { EventEmitter, Injectable, Type } from '@angular/core';

import { SportsUserSettings } from '@frontend/sports/common/client-config-data-access';
import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';
import { BetslipDigitalModule } from 'packages/sports/common/betslip/digital/betslip-digital.module';

import { ComponentLoaderService, ComponentProxy } from '../deferred/component-loader.service';
import ModuleLoaderService from '../deferred/module-loader.service';

export interface RightColumnBinding {
    inColumn: boolean;
}

export interface EditMyBetAddPicksContainerMobileComponentBinding {
    picksContainerBottomOffset: EventEmitter<number>;
}

export interface BetslipBarComponentBindings {
    barClick: EventEmitter<void>;
    myBetsClick: EventEmitter<void>;
}

@Injectable({ providedIn: 'root' })
export class BetslipDigitalComponentLoaderService extends ComponentLoaderService<BetslipDigitalModule> {
    moduleName = 'BetslipDigitalModule';

    constructor(
        moduleLoader: ModuleLoaderService,
        loggerFactory: LoggerFactory,
        private sportsUserSettings: SportsUserSettings,
    ) {
        super(moduleLoader, loggerFactory);
    }

    getBetslipComponent(): ComponentProxy<RightColumnBinding> {
        return this.getComponentProxy((module) => module.betslipComponent, undefined, this.sportsUserSettings);
    }

    getEditBetComponent(): ComponentProxy<RightColumnBinding> {
        return this.getComponentProxy((module) => module.editBetComponent, undefined, this.sportsUserSettings);
    }

    getQuickBetComponent(): ComponentProxy {
        return this.getComponentProxy((module) => module.quickBetContainerComponent, undefined, this.sportsUserSettings);
    }

    getEditBetAddPicksContainerMobileComponent(): ComponentProxy<EditMyBetAddPicksContainerMobileComponentBinding> {
        return this.getComponentProxy((module) => module.editBetAddPicksContainerMobileComponent, undefined, this.sportsUserSettings);
    }

    getModule(): Promise<Type<BetslipDigitalModule>> {
        return import(/* webpackChunkName: "betslip-digital" */ 'packages/sports/common/betslip/digital/betslip-digital.module').then(
            (m) => m.BetslipDigitalModule,
        );
    }

    getRewardTokensComponent(): ComponentProxy {
        return this.getComponentProxy((module) => module.rewardTokensBannerComponent, undefined, this.sportsUserSettings);
    }

    getBetslipReturnsMessageComponent(): ComponentProxy {
        return this.getComponentProxy((module) => module.betslipReturnsMessagesComponent, undefined, this.sportsUserSettings);
    }

    getBetslipBarComponent(): ComponentProxy<BetslipBarComponentBindings> {
        return this.getComponentProxy((module) => module.betslipBarComponent, undefined, this.sportsUserSettings);
    }
}
